export const getMenuGaAttributes = (category, action, label) => ({
    'data-ga-category': category,
    'data-ga-action': action,
    'data-ga-label': `Link - ${label}`,
});
